import React, { useEffect, useState } from "react";
import Container from "../../blocks/Container";
import { Spinner } from "@fluentui/react-components";
import { useMessage } from "../../blocks/message/MessageContext";
import { allowedContentType } from "../../utils/Helpers";
import Ows from "../../utils/OwsHandler";
import { getUser } from "../../auth/user-slice";
import { useSelector } from "react-redux";

const VacancyProcessor = ({ document, onFinish }) => {
  const { showMessage } = useMessage();
  const [loading, setLoading] = useState(false);
  const user = useSelector(getUser);
  
  useEffect(() => {
    (async () => {
      const documentId = await uploadDocument(document);
      if (documentId) {
        try {
          setLoading(true);
          const vacancyId = await createVacancy();
          const data = await processVacancy(documentId, vacancyId);
  
          if (data.error) {
            throw new Error(data.error.message);
          }
  
          showMessage("success", "Document processed successfully");
        } catch (error) {
          console.error(error);
          showMessage("error", "An error occurred while processing the document");
        } finally {
          setLoading(false);
          onFinish();
        }
      } else {
        onFinish();
      }
    })();
  }, [document]);

  const uploadDocument = async (doc) => {
    const allowedDocType = allowedContentType(doc.contentType);

    if (!allowedDocType) {
      showMessage("error", "Invalid document type. Allowed types are PDF, DOC, DOCX");
      return;
    }

    try {
      const data = await Ows.handleRequest("Otys.Services.FileContentService.save", [doc.name, doc.content]);
      
      if (data.error) {
        throw new Error(data.error.message);
      }

      return data.response.ouid;
    } catch (error) {
      console.error(error);
    }
  }

  const createVacancy = async () => {
    try {
      const data = await Ows.handleRequest("Otys.Services.VacancyService.add", [{
        title: "New job",
        userId: user.id,
      }]);
      
      if (data.error) {
        throw new Error(data.error.message);
      }

      return data.response;
    } catch (error) {
      console.error(error);
    }
  }

  const processVacancy = async (documentId, vacancyId) => {
    try {
      const data = await Ows.handleRequest("Otys.Services.VacancyService.jobParseFromFile", [{
        fileId: documentId,
        vacUid: vacancyId,
      }]);
      
      if (data.error) {
        throw new Error(data.error.message);
      }

      return data.response;
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Container>
      {loading ? (
        <Spinner label="Processing document..." labelPosition="above" /> 
      ) : (
        <></>
      )}
    </Container>
  );
};

export default VacancyProcessor;
